import { useEffect, useRef } from 'react'
import type { DayButtonProps } from 'react-day-picker'

import { cn } from '@/legacy-src/lib/utils'

export type ClientBookingMonthCalendarDayButtonProps = DayButtonProps

export const ClientBookingMonthCalendarDayButton = ({
  day,
  modifiers,
  className,
  ...props
}: ClientBookingMonthCalendarDayButtonProps) => {
  const ref = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    if (modifiers.focused) {
      ref.current?.focus()
    }
  }, [modifiers.focused])

  return (
    <button
      {...props}
      ref={ref}
      type="button"
      className={cn(
        'relative inline-flex size-9 appearance-none items-center justify-center rounded-xl border-0 bg-blue-500 p-0 text-[13px] font-semibold text-petrol-500 ring-offset-background transition-colors hover:bg-petrol-300 hover:text-white-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none',
        {
          'bg-transparent text-sand-700': modifiers.disabled,
          'bg-petrol-500 text-white-500 hover:bg-petrol-500': modifiers.selected,
          'border-2 border-solid border-sand-700 bg-transparent text-sand-700': modifiers.today && modifiers.disabled,
        },
        className,
      )}
      disabled={modifiers.selected || modifiers.disabled}
    >
      {day.date.getDate()}
      <div className="absolute inset-x-0 bottom-1 left-0 flex h-1.5 justify-center gap-0.5">
        {modifiers.hasAppointment ? (
          <div className={cn('size-1.5 rounded-full bg-peach-500', { 'bg-sand-700': modifiers.disabled })} />
        ) : null}
        {modifiers.hasSelectedSlot ? (
          <div className={cn('size-1.5 rounded-full bg-petrol-500', { 'bg-white-500': modifiers.selected })} />
        ) : null}
      </div>
    </button>
  )
}
